import React from 'react';
import styles from './technical_capabilities.module.css';

const capabilities = [
    {
        title: '웹·모바일 앱 개발',
        details: ['사용자 앱·관리자 웹 개발', '서버 API·외부 서비스 연결', '푸시 알림·IoT 센서 연동'],
        technologies: 'React · Next.js · Flutter · React Native · Firebase · Vercel · MQTT · FCM',
    },
    {
        title: '데이터 처리·분석 시스템',
        details: ['데이터 수집·변환(ETL)', '배치 작업·대용량 데이터 처리', '분석 환경 구성·센서 데이터 분석'],
        technologies: 'Python · Hadoop · Spark · Kafka · Flume · Spring Batch · SQL',
    },
    {
        title: '백엔드·서비스 인프라',
        details: ['업무 로직·API·데이터베이스 개발', '기존 시스템 기능개선', '클라우드 배포·Docker·CI/CD 구성'],
        technologies: 'Spring Boot · Node.js · MySQL · MongoDB · Redis · Docker · AWS',
    },
    {
        title: '기술 컨설팅·AX 활용',
        details: ['데이터 플랫폼 검토·개선 방향 제안', '기술 도입 컨설팅', '자체 개발·문서 업무에 AI 활용'],
        technologies: '데이터 플랫폼 검토 · AI 활용 개발 · 지식·문서 업무 효율화',
        label: '컨설팅 및 자체 활용 분야',
    },
    {
        title: '아키텍처 설계',
        details: ['서비스 구조·데이터 흐름 설계', '배치 처리·실행 환경 설계', '기업 시스템 경량화'],
        technologies: '애플리케이션 구조 · 데이터 흐름 · 배치·인프라 설계',
        label: '설계 범위',
    },
    {
        title: '실무 기술 교육',
        details: ['개념 설명·코드 실습', '클라우드 환경 구성·실습', '프로젝트 구현 중심 교육', 'AI를 활용한 교육 콘텐츠 제작'],
        technologies: '소프트웨어 개발 · 클라우드 · 데이터 분석 · 인공지능 분석 환경',
        label: '교육 분야',
    },
];

export default function TechnicalCapabilities() {
    return (
        <section className={styles.section} aria-labelledby="technical-capabilities-title">
            <h2 id="technical-capabilities-title">기술 역량</h2>
            <p className={styles.intro}>앱·시스템 개발부터 컨설팅·설계·교육까지 지원합니다.</p>
            <ul className={styles.methods}>
                {capabilities.map(({ title, details, technologies, label }) => (
                    <li className={styles.method} key={title}>
                        <h3>{title}</h3>
                        <div className={styles.content}><ul className={styles.points}>{details.map(detail => <li key={detail}>{detail}</li>)}</ul>
                        <p className={styles.technologies}><strong>{label || '활용 기술'}</strong><br />{technologies}</p></div>
                    </li>
                ))}
            </ul>
        </section>
    );
}
